var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9682 9.85397C22.8924 9.60934 22.6907 9.43105 22.4479 9.39412L15.6278 8.35517L12.5777 1.87661C12.4692 1.64599 12.2451 1.5 11.9998 1.5C11.7544 1.5 11.5304 1.64599 11.4218 1.87661L8.37157 8.35517L1.5516 9.39412C1.30887 9.43105 1.10713 9.60934 1.03133 9.85393C0.955493 10.0986 1.01874 10.3671 1.19444 10.5466L6.12929 15.5894L4.9645 22.7102C4.923 22.9637 5.02242 23.2198 5.2209 23.371C5.33317 23.4565 5.46616 23.5 5.59979 23.5C5.7024 23.5 5.80535 23.4744 5.89963 23.4224L11.9997 20.0604L18.0996 23.4223C18.3168 23.542 18.5799 23.5221 18.7784 23.371C18.9769 23.2198 19.0763 22.9636 19.0349 22.7101L17.8697 15.5894L22.8051 10.5465C22.9808 10.3671 23.044 10.0986 22.9682 9.85397Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.832fe77b.svg";
export { ForwardRef as ReactComponent };